module.exports = __webpack_public_path__ + "static/media/Cancel Blue.7bc39fdc.svg";